import {Observable, catchError, map, of} from "rxjs";
import {ErrorHandlingUtil} from "./error-handling-util";

export interface BulkItemResult {
    ok: boolean;
    error?: string;
}

export interface BulkSummary {
    count: number;
    failed: number;
    firstError?: string;
}

/**
 * Wraps a single bulk-operation request so it never throws: a failure becomes a {ok: false} result
 * instead of erroring the surrounding forkJoin. This lets a bulk op report partial success rather than
 * discarding the whole batch when one item fails.
 */
export function toBulkResult<T>(source: Observable<T>): Observable<BulkItemResult> {
    return source.pipe(
        map((): BulkItemResult => ({ok: true})),
        catchError((errorResponse: any) => of<BulkItemResult>({ok: false, error: ErrorHandlingUtil.getErrorMessage(errorResponse)}))
    );
}

/** Aggregates per-item results from a bulk operation into success/failure counts. */
export function summarizeBulkResults(results: BulkItemResult[]): BulkSummary {
    const failures = results.filter((result) => !result.ok);
    return {
        count: results.length - failures.length,
        failed: failures.length,
        firstError: failures[0]?.error
    };
}
